import Translations from "../../libs/Translations";
import React from "react";
import * as Attributes from "../../libs/Attributes";
import { isViewDossier } from "../../libs/UrlHelpers";
import AttributesStore from "../../stores/AttributesStore";
import createReactClass from "create-react-class";
import ElstrLangStore from "elstr-jslib/src/scripts/stores/ElstrLangStore";
import PropTypes from "prop-types";
import { arrayMoveImmutable } from "../../libs/Array";
import { DndContext } from "@dnd-kit/core";
import { SortableContext, useSortable, verticalListSortingStrategy } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

function toDisableCheckbox(dataAttributeKey) {
  // we disable the attribute "sMatHdrTdline" since it is redundant in the dossier functionality
  return dataAttributeKey === "sMatHdrTdline" && isViewDossier();
}

const SortableItem = props => {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id: props.value });
  let classNameCheckbox = "item-setting-list__item";
  let dataAttributeKey = props.value;
  let label = Translations.getLabel(dataAttributeKey) || "";

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  const id = `setting--${props.value}`;

  if (props.checked) classNameCheckbox += " item-setting-list__item--checked";
  return (
    <li ref={setNodeRef} className={classNameCheckbox} style={style} {...attributes} {...listeners}>
      <input
        id={id}
        className="item-setting-list__checkbox"
        type="checkbox"
        name={props.value}
        checked={props.checked}
        disabled={toDisableCheckbox(dataAttributeKey)}
        // https://github.com/clauderic/dnd-kit/issues/1264#issuecomment-2112384617
        onPointerDown={e => e.stopPropagation()}
        onChange={() => AttributesStore.toggleAttributes(props.checked, props.position, props.type)}
      />
      <label htmlFor={id}>{label}</label>
      <span className="ficon ficon__table-option item-setting-list__option" />
    </li>
  );
};

const SortableList = ({ items, checked, allowed, type }) => {
  function getClassName(type) {
    let className = `item-list__setting-layer`;
    if (type === Attributes.TYPES.packagingDossier) {
      className = `item-list__setting-layer-packaging-dossier`;
    }

    if (type !== Attributes.TYPES.result) {
      className = `${className} ${className}__dossier`;
    }
    return className;
  }

  return (
    <div className={getClassName(type)}>
      <ul className="item-setting__list">
        {items
          .filter((value, index) => allowed[index] === true)
          .map((value, index) => (
            <SortableItem
              key={`item-${index}`}
              index={index}
              position={index}
              value={value}
              checked={checked[index]}
              type={type}
            />
          ))}
      </ul>
    </div>
  );
};

// from example: https://docs.dndkit.com/presets/sortable
const ItemListOverlaySettings = createReactClass({
  mixins: [AttributesStore.mixin, ElstrLangStore.mixin],

  propTypes: {
    type: PropTypes.string.isRequired, // Attributes.TYPE
  },

  _setState: function () {
    let attributes = Attributes.getAttributesByType(this.props.type);

    let dataAttributeKeys = [];
    let listDisplayDefaults = [];
    let listDisplayAllowed = [];

    attributes.forEach(attribute => {
      dataAttributeKeys.push(attribute["dataAttributeKey"]);
      listDisplayDefaults.push(attribute["listDisplayDefault"]);
      listDisplayAllowed.push(attribute["listDisplayAllowed"]);
    });

    return {
      items: dataAttributeKeys,
      checked: listDisplayDefaults,
      allowed: listDisplayAllowed,
    };
  },

  getInitialState: function () {
    return this._setState();
  },

  storeDidChange: function () {
    this.setState(this._setState());
  },

  onDragEnd: function (that, event) {
    const { type } = this.props;
    const { items } = this.state;
    const { active, over } = event;

    if (active.id !== over.id) {
      const oldIndex = items.indexOf(active.id);
      const newIndex = items.indexOf(over.id);

      const attributes = Attributes.getAttributesByType(type);
      const newAttributesOrder = arrayMoveImmutable(attributes, oldIndex, newIndex);

      AttributesStore.setAttributesByType(newAttributesOrder, type);
    }
  },

  render: function () {
    let that = this;

    return (
      <DndContext onDragEnd={this.onDragEnd.bind(this, that)}>
        <SortableContext items={this.state.items} strategy={verticalListSortingStrategy}>
          <SortableList
            items={this.state.items}
            checked={this.state.checked}
            allowed={this.state.allowed}
            type={this.props.type}
          />
        </SortableContext>
      </DndContext>
    );
  },
});

export default ItemListOverlaySettings;
